/** @jsxImportSource @emotion/react */
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { SIDE_NAV_WIDTH, SIDE_NAV_DARK, NAV_TYPE_SIDE } from 'constants/ThemeConstant';
import MenuContent from './MenuContent';
import Logo from './Logo';
import NavProfile from './NavProfile';
import { css } from '@emotion/react';
import { TEMPLATE, GRAY_SCALE, DARK_MODE } from "constants/ThemeConstant";
import { useSelector } from 'react-redux';
import utils from 'utils';

const { Sider } = Layout;

export const SideNav = ({navCollapsed, routeInfo, hideGroupTitle, currentTheme }) => {
  const sideNavTheme = useSelector(state => state.theme.sideNavTheme);
  const headerNavColor = useSelector(state => state.theme.headerNavColor);
  const isDarkTheme = currentTheme === 'dark';
  
  // Calculate nav mode for logo and profile
  const navMode = (() => {
    if (sideNavTheme === SIDE_NAV_DARK) {
      return 'light'; // Light elements on dark sidebar
    }
    if (!headerNavColor) {
      return utils.getColorContrast(isDarkTheme ? '#000000' : '#ffffff');
    }
    return utils.getColorContrast(headerNavColor);
  })();

  const props = { sideNavTheme, routeInfo , hideGroupTitle }
  
  return (
    <Sider 
      css={css`
        height: 100vh !important; 
        position: fixed !important;
        top: 0px;
        overflow: hidden;
        z-index: 999;
        direction: ltr;
        ${currentTheme === 'light' && sideNavTheme !== SIDE_NAV_DARK ? `background-color: ${GRAY_SCALE.WHITE} !important;`  : `background-color: ${TEMPLATE.SIDE_NAV_DARK_BG_COLOR} !important;`}
        ${currentTheme === 'dark' && sideNavTheme !== SIDE_NAV_DARK ? `background-color: ${DARK_MODE.BG_COLOR} !important`  : ``}
        ${currentTheme === 'dark' && sideNavTheme === SIDE_NAV_DARK ? `background-color: ${TEMPLATE.SIDE_NAV_DARK_BG_COLOR} !important`  : ``}
        
        .ant-layout-sider-children {
          height: 100vh;
          display: flex;
          flex-direction: column;
          position: relative;
        }
      `}
      className={`side-nav ${sideNavTheme === SIDE_NAV_DARK? 'side-nav-dark' : ''}`} 
      width={SIDE_NAV_WIDTH} 
      collapsed={navCollapsed}
    >
      {/* Logo Section */}
      <div css={css`
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      `}>
        <Logo logoType={navMode} />
      </div>
      
      {/* Menu Content - Takes remaining space */}
      <div css={css`
        flex: 1;
        overflow: hidden;
        padding: 16px 0;
        padding-bottom: 80px; /* Space for profile */
      `}>
        <MenuContent 
          type={NAV_TYPE_SIDE}
          {...props}
        />
      </div>
      
      {/* Profile Section - Absolutely positioned at bottom */}
      <div css={css`
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 16px;
        border-top: 1px solid ${sideNavTheme === SIDE_NAV_DARK ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'};
        background-color: inherit;
      `}>
        <NavProfile mode={navMode} />
      </div>
    </Sider>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme, currentTheme } =  theme;
  return { navCollapsed, sideNavTheme, currentTheme }
};

export default connect(mapStateToProps)(SideNav);